import { makeStyles, withStyles } from '@material-ui/core';
import List from '@material-ui/core/List';
import SliderMui from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
  input: {
    '& label': {
      transform: 'translate(0, 1.5px)',
      width: '100%',
      '& .label--required': {
        color: theme.palette.primary.main,
      },
      '& .label--icon-valid': {
        color: theme.palette.primary.main,
      },
    },
  },
  sliderContainer: {
    marginTop: '2rem',
  },
}));

const Slider = withStyles({
  root: {
    height: '10px',
    margin: 0,
    color: '#88C827',
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#88C827',
    border: '1px solid #000',
    marginTop: -6,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  track: {
    border: '1px solid #000',
    height: '10px',
    borderRadius: '10px',
  },
  rail: {
    opacity: 1,
    backgroundColor: '#fff',
    border: '1px solid #000',
    height: '10px',
    borderRadius: '10px',
  },
  markLabel: {
    display: 'none',
  },
  markActive: {
    opacity: 0,
  },
  mark: {
    opacity: 0,
  },
})(SliderMui);

const SliderListMarks = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 0,
    fontSize: '10px',

    '& .MuiListItem-root': {
      width: 'auto',
      position: 'relative',
      padding: 0,
      justifyContent: 'center',

      '&:hover': {
        backgroundColor: 'transparent',
      },
      '&:first-child': {
        justifyContent: 'left',
      },
      '&:nth-child(2)': {
        left: '11px',
      },
      '&:nth-child(3)': {
        left: '18px',
      },
      '&:nth-child(4)': {
        left: '25px',
      },
      '&:last-child': {
        justifyContent: 'right',
      },
    },
  },
})(List);

export { Slider, SliderListMarks, useStyles };
